var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 145 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_139_4881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.0225 17.4965C83.3878 17.4965 84.4941 16.3897 84.4941 15.0239V2.49613C84.4941 1.13032 83.3878 0 82.0225 0C80.6571 0 79.5508 1.10677 79.5508 2.47258V15.0003C79.5508 16.3661 80.6571 17.4729 82.0225 17.4729V17.4965Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4543 23.3347C48.9486 23.9941 49.6783 24.3473 50.4551 24.3473C50.973 24.3473 51.4674 24.1825 51.9146 23.8763C53.021 23.0757 53.2564 21.5215 52.456 20.4147L45.041 10.3125C44.2406 9.2057 42.687 8.97021 41.5807 9.77086C40.4743 10.5715 40.2389 12.1257 41.0392 13.2325L48.4543 23.3347Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.612 20.4171C110.788 21.5239 111.047 23.0781 112.153 23.8787C112.601 24.2084 113.118 24.3497 113.613 24.3497C114.366 24.3497 115.143 23.9965 115.614 23.3371L123.029 13.2348C123.853 12.1281 123.594 10.5739 122.487 9.77323C121.381 8.94904 119.827 9.20807 119.027 10.3148",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.219 46.1908C50.219 46.1908 50.2425 46.1908 50.2661 46.2144L64.0133 57.8237C64.3428 58.0827 64.6018 58.4124 64.8842 58.7421C65.0961 58.8363 65.2844 58.9069 65.4727 59.0718C66.485 59.9195 67.8032 60.3198 69.1449 60.2256C70.4867 60.1079 71.7108 59.4956 72.5582 58.4595C73.4763 57.5176 73.8764 56.4344 73.8294 55.2098C73.7587 53.7498 73.0761 52.3134 71.9462 51.395L64.9784 45.5079L54.9505 37.0305C52.8319 35.2408 49.654 35.5234 47.865 37.6427C46.076 39.7621 46.3585 42.9411 48.477 44.7308L50.2425 46.2379L50.219 46.1908Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2541 48.7881C77.7371 50.5307 78.6551 52.7207 78.7493 55.0285C78.867 57.6423 77.9489 60.0678 76.1599 61.834C74.5827 63.7178 72.1817 64.9659 69.5217 65.1778C69.2392 65.2014 68.9332 65.2249 68.6507 65.2249C68.2976 65.2249 67.9445 65.1778 67.5914 65.1307C67.5914 65.1778 67.5914 65.2014 67.5914 65.2485C67.7091 67.8623 66.7911 70.2878 65.0256 72.0775C63.166 74.291 60.4354 75.4449 57.6812 75.4685C58.1049 78.2236 57.4223 81.1201 55.492 83.4043C54.1032 85.0527 52.2906 86.0888 50.3368 86.5833C50.9488 87.7607 51.349 89.0559 51.4667 90.4217C51.6786 93.0827 50.8782 95.673 49.1598 97.6981C47.4414 99.7233 45.0404 100.971 42.3804 101.183C42.0979 101.183 41.7919 101.23 41.5094 101.23C39.1554 101.23 36.9191 100.406 35.083 98.8756L27.362 92.3762L0.90332 116.019L28.2094 145.996L64.5313 111.121C65.1198 110.603 65.8966 110.391 66.6498 110.556C71.7344 111.568 76.0187 112.275 80.044 111.992C80.091 111.992 80.1146 111.992 80.1617 111.992C84.7284 111.639 88.9655 110.037 93.6264 106.105L118.743 83.3336C118.743 83.3336 122.086 80.2488 119.685 77.5172C118.39 76.0572 116.813 74.9975 115.095 74.4323C117.731 70.8059 117.684 65.6959 114.647 62.1165C113.353 60.5859 111.658 59.4791 109.751 58.9611C111.87 55.4052 111.611 50.7427 108.81 47.4223C107.256 45.5856 105.137 44.4081 102.783 44.0078C103.843 40.8288 103.56 36.8962 100.947 34.4236C98.3108 31.9275 94.1207 34.4472 94.1207 34.4472L76.2776 48.7646L76.2541 48.7881Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8985 109.851C93.0851 113.077 89.4835 114.984 85.8584 116.021L120.015 145.903L144.096 116.044L116.86 91.7422L96.8985 109.827V109.851Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1081 34.1878C64.9076 35.9775 64.578 38.7091 66.3435 40.1927L72.5345 45.4204L82.7507 37.2256L73.2877 32.7985C69.0741 30.6085 66.8614 33.034 66.1081 34.1878Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7299 72.4133L39.3672 76.3223C39.3672 76.3223 39.3672 76.3459 39.3907 76.3694L44.6401 80.7965C46.7587 82.5626 49.9366 82.3036 51.7256 80.1843C53.5146 78.0649 53.2321 74.8859 51.1135 73.0962L41.2268 64.7365C41.2268 64.7365 41.2268 64.7365 41.2033 64.7365C40.1911 63.8652 38.8729 63.4649 37.5546 63.5826C36.2129 63.7004 34.9888 64.3126 34.1414 65.3488C32.3524 67.4681 32.6348 70.6472 34.7534 72.4368L34.7299 72.4133Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.956 50.629C39.1086 51.6416 38.6848 52.9603 38.8025 54.3026C38.9202 55.6448 39.5323 56.8458 40.568 57.7171L44.3579 60.9197C44.3579 60.9197 44.3579 60.9197 44.3815 60.9197L54.3152 69.3264C56.4338 71.1161 59.6117 70.8335 61.4007 68.7142C62.3188 67.7722 62.7189 66.689 62.6719 65.4645C62.6012 64.0045 61.9186 62.568 60.7887 61.6497L47.0415 50.0403H47.0179C44.8993 48.2506 41.745 48.5097 39.956 50.629Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6927 87.8075L38.3317 95.0839C39.344 95.9552 40.6386 96.3555 42.0039 96.2378C43.3457 96.12 44.5462 95.5078 45.4172 94.4952C46.2882 93.4591 46.6884 92.1639 46.5942 90.8217C46.5 89.4794 45.8645 88.2549 44.8287 87.4071L41.4861 84.6049L36.1426 80.0836C34.024 78.3645 30.8932 78.6471 29.1277 80.7429C27.3387 82.8623 27.6212 86.0413 29.7397 87.831L29.6927 87.8075Z",
    fill: "#00A90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_139_4881",
    x: 0.90332,
    y: 0,
    width: 143.192,
    height: 149.992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_139_4881"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.4285f96c3ee4c33d34f2226f3be27e5f.svg";
export { ForwardRef as ReactComponent };